/* Anneaux de satisfaction : ils se remplissent quand la section entre dans
   le viewport. Le HTML/CSS les rend deja remplis — ce script les vide
   d abord, puis relache. Si le script ne tourne pas (ou si l on demande
   moins d animation), le chiffre reste lisible, simplement sans transition. */
(function () {
  var rings = document.querySelectorAll("[data-ckey-ring]");
  if (!rings.length) return;

  if (
    !("IntersectionObserver" in window) ||
    (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches)
  ) {
    return;
  }

  for (var i = 0; i < rings.length; i++) rings[i].classList.add("is-empty");

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.remove("is-empty");
        io.unobserve(entry.target);
      });
    },
    { threshold: 0.4 }
  );

  for (var j = 0; j < rings.length; j++) io.observe(rings[j]);
})();
